export default __webpack_public_path__ + "static/Creative-Solutions-dca83800f03380b44945f1ebb9d3d9a2.webp";